import { PIN_FEEDBACK } from '../config/pin';
import type { PinChallenge } from '../sim/PinChallenge';

/** Render time keeps the success acknowledgement ticking after the run stops. */
export class PinFeedback {
  private pin: PinChallenge | null = null;
  private errors = 0;
  private errorAt = -Infinity;
  private successAt: number | null = null;

  update(pin: PinChallenge, now: number) {
    if (pin !== this.pin) {
      this.pin = pin;
      this.errors = 0;
      this.errorAt = -Infinity;
      this.successAt = null;
    }
    if (pin.errors !== this.errors) {
      this.errors = pin.errors;
      this.errorAt = now;
    }
    if (pin.complete && this.successAt === null) this.successAt = now;
    const errorAge = now - this.errorAt;
    const error = !pin.complete && errorAge < PIN_FEEDBACK.errorSeconds;
    const results = this.successAt !== null && now - this.successAt >= PIN_FEEDBACK.successSeconds;
    return {
      error,
      dimmed: error && Math.floor(errorAge / PIN_FEEDBACK.blinkSeconds) % 2 === 1,
      success: pin.complete && !results,
      results,
    };
  }
}
